import { ColumnDef } from "@tanstack/react-table";
import { AxiosError, AxiosResponse } from "axios";
import React, { useEffect, useState, useRef } from "react";
import DataTable2 from "shared/DataTable2";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import { Option } from "../../interface/Option";
import { DrugNotAllowedwithActivityAxiosInstance } from "../../Network/DrugNotAllowedwithActivityAxiosInstance";
import {
  drugNotAllowedwithActivity,
  Datum,
} from "../../interface/DrugNotAllowedwithActivity";
import ListOfDrugCode from "../Shared/DrugCode";
import ListOfDrugMedical from "../Shared/DrugMedicalGroup";
import ListOfDrugCustom from "../Shared/DrugCustomGroup";
import ListOfNewNetworkName from "../Shared/NewNetworkName";
import ListOfInsuranceplanName from "../Shared/ListOfInsuranceplanName";
import Patient from "../Shared/Patient";
import ListOfProviderName from "../Shared/ListOfProviderName";
import PolicyNames from "../Shared/PolicyNames";
import ListofActivityCode from "../Shared/ListOfActivityCode";
import ActivitySelector from "../Shared/ActivityType";
import ListOfActivityCustom from "../Shared/ListOfActivityCustom";
import ListOfActivityMedical from "../Shared/ListOfActivityMedical";
import ListOfDoctorName from "../Shared/Doctor";
import FileUpload from "Pages/uploadFile/DrugNotAllowedwithActivity/DrugNotAllowedwithActivity";

const DrugNotAllowedwithActivity: React.FC = () => {
  // Main data state
  const [items, setItems] = useState<drugNotAllowedwithActivity>({
    result: [],
  });

  // Form states
  const [relationName, setRelationName] = useState<string>("");
  const [drug, setDrug] = useState<Option[]>([]);
  const [drugMedicalGroups, setDrugMedicalGroups] = useState<Option[]>([]);
  const [drugCustomGroups, setDrugCustomGroups] = useState<Option[]>([]);
  const [ActivityType, setActivityType] = useState<string>("");
  const [activity, setActivity] = useState<Option[]>([]);
  const [activityMedicalGroups, setActivityMedicalGroups] = useState<Option[]>(
    []
  );
  const [activityCustomGroups, setActivityCustomGroups] = useState<Option[]>(
    []
  );
  const [provider, setProvider] = useState<Option[]>([]);
  const [applyToOtherProviders, setApplyToOtherProviders] =
    useState<boolean>(false);
  const [networks, setNetworks] = useState<Option[]>([]);
  const [apply_to_other_networks, setApply_to_other_networks] =
    useState<boolean>(false);
  const [insuranceplan, setInsuranceplan] = useState<Option[]>([]);
  const [apply_to_other_insuranceplan, setapply_to_other_insuranceplan] =
    useState<boolean>(false);
  const [Payer, setPayer] = useState<string[]>([]);
  const [apply_to_other_payer, setapply_to_other_payer] =
    useState<boolean>(false);
  const [patients, setPatients] = useState<Option[]>([]);
  const [apply_to_other_patients, setApply_to_other_patients] =
    useState<boolean>(false);
  const [policy, setPolicy] = useState<Option[]>([]);
  const [apply_to_other_policy, setApply_to_other_policy] =
    useState<boolean>(false);
  const [userLevel, setUserLevel] = useState<string[]>([]);
  const [apply_to_other_user, setApply_to_other_user] =
    useState<boolean>(false);
  const [apply_to_other_vip, setApply_to_other_vip] = useState<boolean>(false);
  const [doctor, setDoctor] = useState<Option[]>([]);
  const [applyToOtherDoctor, setApplyToOtherDoctor] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean>(true);

  // UI control states
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [clearDrug, setClearDrug] = useState(false);
  const [clearDrugMedicalGroups, setClearDrugMedicalGroups] = useState(false);
  const [clearDrugCustomGroups, setClearDrugCustomGroups] = useState(false);
  const [clearActivity, setClearActivity] = useState(false);
  const [clearActivityMedicalGroups, setClearActivityMedicalGroups] =
    useState(false);
  const [clearActivityCustomGroups, setClearActivityCustomGroups] =
    useState(false);
  const [clearNetworks, setClearNetworks] = useState(false);
  const [clearInsuranceplan, setClearInsuranceplan] = useState(false);
  const [clearProvider, setClearProvider] = useState(false);
  const [clearPatient, setClearPatient] = useState(false);
  const [clearPolicy, setClearPolicy] = useState(false);
  const [activityTypeisValid, setActivityTypeIsValid] = useState<boolean>(true);
  const [clearDoctor, setClearDoctor] = useState(false);

  // dialog for details
  const [selectedItem, setSelectedItem] = useState<Datum | null>(null);
  const dialogRef = useRef<HTMLDialogElement | null>(null);
  const [selectedDrugOption, setSelectedDrugOption] = useState<string | null>(
    null
  );
  const [selectedActivityOption, setSelectedActivityOption] = useState<
    string | null
  >(null);
  // class css for apply
  const hasSelectValue = !!selectedActivityOption;
  const hasSelectValue2 = !!selectedDrugOption;
  // Get token from localStorage
  const token = localStorage.getItem("token") || "";

  // Initialize toast
  const { toast } = useToast();

  // Fetch initial data on component mount
  useEffect(() => {
    fetchItems();
  }, []);

  // Clear form function
  const clear = () => {
    setRelationName("");
    setDrug([]);
    setDrugMedicalGroups([]);
    setDrugCustomGroups([]);
    setActivity([]);
    setActivityMedicalGroups([]);
    setActivityCustomGroups([]);
    setActivityType("");
    setProvider([]);
    setApplyToOtherProviders(false);
    setNetworks([]);
    setApply_to_other_networks(false);
    setInsuranceplan([]);
    setapply_to_other_insuranceplan(false);
    setPayer([]);
    setapply_to_other_payer(false);
    setPatients([]);
    setApply_to_other_patients(false);
    setApply_to_other_vip(false);
    setApply_to_other_policy(false);
    setApply_to_other_user(false);
    setPolicy([]);
    setUserLevel([]);
    setSelectedActivityOption(null);
    setSelectedDrugOption(null);
    setDoctor([]);
    setApplyToOtherDoctor(false);
    setIsActive(true);
  };

  // Dialog details control handlers
  const handleOpenDialog = (item: Datum) => {
    setSelectedItem(item);
    dialogRef.current?.showModal();
  };

  const handleCloseDialog = () => {
    dialogRef.current?.close();
    setSelectedItem(null);
  };

  // Dialog control handlers
  const handleAddClick = () => {
    setEditIndex(null);
    clear();
    setIsDialogOpen(true);
  };

  const handleEditClick = (item: Datum) => {
    handleEdit(item);
    setIsDialogOpen(true);
  };

  // Handlers for form inputs

  const handleActivityTypeChange = (ActivityType: string) => {
    setActivityType(ActivityType); //Update the status of the selected activityType
  };
  const handleDrugChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setDrug(selectedOptions);
  };

  const handleDrugMedicalGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setDrugMedicalGroups(selectedOptions);
  };

  const handleActivityChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setActivity(selectedOptions);
  };
  const handleActivityMedicalGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setActivityMedicalGroups(selectedOptions);
  };

  const handleActivityCustomGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setActivityCustomGroups(selectedOptions);
  };

  const handleDrugCustomGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setDrugCustomGroups(selectedOptions);
  };
  const handlePoliciesChange = (selectedOptions: Option[]) => {
    setPolicy(selectedOptions);
  };
  const handlePatientChange = (selectedOptions: Option[]) => {
    setPatients(selectedOptions);
  };
  const handleProviderChange = (selectedOptions: Option[]) => {
    setProvider(selectedOptions);
  };

  const handleNetworkChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setNetworks(selectedOptions);
  };

  const handleInsurancePlanChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setInsuranceplan(selectedOptions);
  };
  const handleDoctorChange = (selectedOptions: Option[]) => {
    setDoctor(selectedOptions);
  };

  // API Functions
  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Datum[] }> =
        await DrugNotAllowedwithActivityAxiosInstance.get(
          "getActivityNotAllowedDrugs"
        );
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
      toast({
        title: "Error",
        description: "Failed to fetch Drug Not Allowed With Activity",
        variant: "destructive",
      });
    }
  };

  const addItem = async (): Promise<void> => {
    if (!relationName.trim()) {
      toast({
        title: "Error",
        description: "Relation Name is required and cannot be empty.",
        variant: "destructive",
      });
      return;
    }
    if (relationName.trim().length < 3) {
      toast({
        title: "Error",
        description: "Relation Name must be at least 3 characters long.",
        variant: "destructive",
      });
      return;
    }
    try {
      const ValuesDrug = drug.map((option) => option.value);
      const ValuesDrugMedicalGroups = drugMedicalGroups.map(
        (option) => option.value
      );
      const ValuesDrugCustomGroups = drugCustomGroups.map(
        (option) => option.value
      );
      const ValuesActivity = activity.map((option) => option.value);
      const ValuesActivityMedicalGroups = activityMedicalGroups.map(
        (option) => option.value
      );
      const ValuesActivityCustomGroups = activityCustomGroups.map(
        (option) => option.value
      );
      const ValuesNetwork = networks.map((option) => option.value);
      const ValuesInsurancePlan = insuranceplan.map((option) => option.value);
      const ValuesPolicy = policy.map((option) => option.value);
      const ValuesPatient = patients.map((option) => option.value);
      const ValuesProvider = provider.map((option) => option.value);
      const ValuesDoctor = doctor.map((option) => option.value);
      const newGroupArray = [
        {
          relation_name: relationName,
          drug: ValuesDrug,
          drug_medicalgroups: ValuesDrugMedicalGroups,
          drug_customgroups: ValuesDrugCustomGroups,
          activity_type: ActivityType,
          activity: ValuesActivity,
          activity_medicalgroups: ValuesActivityMedicalGroups,
          activity_customgroups: ValuesActivityCustomGroups,
          provider: ValuesProvider,
          apply_to_other_providers: applyToOtherProviders,
          networks: ValuesNetwork,
          apply_to_other_networks: apply_to_other_networks,
          insuranceplan: ValuesInsurancePlan,
          apply_to_other_insuranceplan: apply_to_other_insuranceplan,
          payer: Payer,
          apply_to_other_payer: apply_to_other_payer,
          patients: ValuesPatient,
          apply_to_other_patients: apply_to_other_patients,
          policy: ValuesPolicy,
          apply_to_other_policy: apply_to_other_policy,
          user_level: userLevel,
          apply_to_other_user: apply_to_other_user,
          apply_to_vip: apply_to_other_vip,
          is_active: isActive,
          doctor: ValuesDoctor,
          apply_to_other_doctor: applyToOtherDoctor,
        },
      ];
      console.log("newGroupArray", newGroupArray);
      const payload = {
        data: newGroupArray,
        token,
      };

      const response = await DrugNotAllowedwithActivityAxiosInstance.post(
        "addnewActivityNotAllowedDrugs",
        payload
      );

      if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);

        toast({
          title: "Success",
          description: "New Drug Not Allowed With Activity Added Successfully.",
        });
      } else {
        const errors = response.data.errors || [];
        const errorMessages = errors
          .map((error: any) => error.error)
          .join("\n");

        toast({
          title: "Error",
          description:
            errorMessages ||
            response.data.message ||
            "Failed to add the group.",
          variant: "destructive",
        });

        console.log(errors);
      }
    } catch (error: AxiosError | any) {
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "An unexpected error occurred.",
        variant: "destructive",
      });
    }
  };

  const handleEdit = (item: Datum) => {
    setRelationName(item.relation_name);

    // Convert text or numbers to Options
    const mapToOptions = (arr: (string | number)[]): Option[] =>
      arr.map((value) => ({
        value: value, // Actual value
        label: value.toString(), // The text that will appear in the Select
      }));
    setDrug(mapToOptions(item.drug));
    setActivity(mapToOptions(item.activity));
    setActivityType(item.activity_type);
    //Convert or process  Custom Drug Groups fields
    const CustomDrugGroupsData = Array.isArray(item.drug_customgroups)
      ? item.drug_customgroups.map((obj) =>
          typeof obj === "string" ? { id: 0, name: obj } : obj
        )
      : [];

    setDrugCustomGroups(
      CustomDrugGroupsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    //Convert or process  medical_Drug_groups fields
    const MedicalDrugGroupsData = Array.isArray(item.drug_medicalgroups)
      ? item.drug_medicalgroups.map((obj) =>
          typeof obj === "string" ? { id: 0, name: obj } : obj
        )
      : [];

    setDrugMedicalGroups(
      MedicalDrugGroupsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    //Convert or process  Custom Activity Groups fields
    const CustomActivityGroupsData = Array.isArray(item.activity_customgroups)
      ? item.activity_customgroups.map((obj) =>
          typeof obj === "string" ? { id: 0, name: obj } : obj
        )
      : [];

    setActivityCustomGroups(
      CustomActivityGroupsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    //Convert or process medical_Activity_groups fields
    const MedicalActivtyGroupsData = Array.isArray(item.activity_medicalgroups)
      ? item.activity_medicalgroups.map((obj) =>
          typeof obj === "string" ? { id: 0, name: obj } : obj
        )
      : [];

    setActivityMedicalGroups(
      MedicalActivtyGroupsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    // Convert or process fields Networks
    const networksData = Array.isArray(item.networks)
      ? item.networks.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setNetworks(
      networksData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );

    //Convert or process insuranceplan fields
    const insuranceplanData = Array.isArray(item.insuranceplan)
      ? item.insuranceplan.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setInsuranceplan(
      insuranceplanData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    // Convert or process fields Providers
    const ProvidersData = Array.isArray(item.provider)
      ? item.provider.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setProvider(
      ProvidersData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    // Convert or process fields Patients
    const PatientsData = Array.isArray(item.patients)
      ? item.patients.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setPatients(
      PatientsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    //Convert or process Policy fields
    const PolicyData = Array.isArray(item.policy)
      ? item.policy.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setPolicy(
      PolicyData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    // Convert or process fields Doctors
    const DoctorsData = Array.isArray(item.doctor)
      ? item.doctor.map(
          (obj) =>
            typeof obj === "string"
              ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
              : obj // If the element is an object, use it as is.
        )
      : [];

    setDoctor(
      DoctorsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );

    setApplyToOtherDoctor(item.apply_to_other_doctor);
    setIsActive(item.is_active);
    setApply_to_other_policy(item.apply_to_other_policy);
    setApply_to_other_user(item.apply_to_other_user);
    setApply_to_other_vip(item.apply_to_vip);
    setUserLevel(item.user_level);
    setApplyToOtherProviders(item.apply_to_other_providers);
    setApply_to_other_networks(item.apply_to_other_networks);
    setapply_to_other_insuranceplan(item.apply_to_other_insuranceplan);
    setPayer(item.payer);
    setapply_to_other_payer(item.apply_to_other_payer);
    setApply_to_other_patients(item.apply_to_other_patients);
    setEditIndex(item.id);
  };

  const updateItem = async (id: string | number): Promise<void> => {
    if (!relationName.trim()) {
      toast({
        title: "Error",
        description: "Relation Name is required and cannot be empty.",
        variant: "destructive",
      });
      return;
    }
    if (relationName.trim().length < 3) {
      toast({
        title: "Error",
        description: "Relation Name must be at least 3 characters long.",
        variant: "destructive",
      });
      return;
    }
    try {
      const ValuesDrug = drug.map((option) => option.value);
      const ValuesDrugMedicalGroups = drugMedicalGroups.map(
        (option) => option.value
      );
      const ValuesDrugCustomGroups = drugCustomGroups.map(
        (option) => option.value
      );
      const ValuesActivity = activity.map((option) => option.value);
      const ValuesActivityMedicalGroups = activityMedicalGroups.map(
        (option) => option.value
      );
      const ValuesActivityCustomGroups = activityCustomGroups.map(
        (option) => option.value
      );
      const ValuesNetwork = networks.map((option) => option.value);
      const ValuesInsurancePlan = insuranceplan.map((option) => option.value);
      const ValuesPolicy = policy.map((option) => option.value);
      const ValuesPatient = patients.map((option) => option.value);
      const ValuesProvider = provider.map((option) => option.value);
      const ValuesDoctor = doctor.map((option) => option.value);
      const updatedItem = {
        data: {
          relation_name: relationName,
          drug: ValuesDrug,
          drug_medicalgroups: ValuesDrugMedicalGroups,
          drug_customgroups: ValuesDrugCustomGroups,
          activity_type: ActivityType,
          activity: ValuesActivity,
          activity_medicalgroups: ValuesActivityMedicalGroups,
          activity_customgroups: ValuesActivityCustomGroups,
          provider: ValuesProvider,
          apply_to_other_providers: applyToOtherProviders,
          networks: ValuesNetwork,
          apply_to_other_networks: apply_to_other_networks,
          insuranceplan: ValuesInsurancePlan,
          apply_to_other_insuranceplan: apply_to_other_insuranceplan,
          payer: Payer,
          apply_to_other_payer: apply_to_other_payer,
          patients: ValuesPatient,
          apply_to_other_patients: apply_to_other_patients,
          policy: ValuesPolicy,
          apply_to_other_policy: apply_to_other_policy,
          user_level: userLevel,
          apply_to_other_user: apply_to_other_user,
          apply_to_vip: apply_to_other_vip,
          is_active: isActive,
          doctor: ValuesDoctor,
          apply_to_other_doctor: applyToOtherDoctor,
          id: id,
        },
        token: token,
      };
      console.log("updatedItem", updatedItem);
      const response = await DrugNotAllowedwithActivityAxiosInstance.put(
        `updateActivityNotAllowedDrugs`,
        updatedItem
      );

      if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
        toast({
          title: "Success",
          description: "Drug Not Allowed With Activity updated successfully.",
        });
      }
    } catch (error: AxiosError | any) {
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "An unexpected error occurred.",
        variant: "destructive",
      });
    }
  };

  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await DrugNotAllowedwithActivityAxiosInstance.delete(
        `deleteActivityNotAllowedDrugs/${id}`,
        {
          data: { token: token },
        }
      );
      fetchItems();
      toast({
        title: "Success",
        description: "Drug Not Allowed With Activity Deleted Successfully.",
      });
    } catch (error) {
      console.error("Error removing item:", error);
      toast({
        title: "Error",
        description: "Failed to delete Drug Not Allowed With Activity",
        variant: "destructive",
      });
    }
  };

  const isRelationRestricted = (item: any): boolean => {
    if (!item) return false;
    const allGroups = [
      ...(Array.isArray(item.drug_medicalgroups) ? item.drug_medicalgroups : []),
      ...(Array.isArray(item.drug_customgroups) ? item.drug_customgroups : []),
      ...(Array.isArray(item.activity_medicalgroups) ? item.activity_medicalgroups : []),
      ...(Array.isArray(item.activity_customgroups) ? item.activity_customgroups : []),
      ...(Array.isArray(item.medical_groups) ? item.medical_groups : []),
      ...(Array.isArray(item.custom_groups) ? item.custom_groups : []),
    ];
    return allGroups.some((g: any) => {
      if (!g) return false;
      if (typeof g === "object") {
        if (g.is_active === false) return true;
        if (typeof g.status === "string" && g.status.toLowerCase() === "inactive") return true;
      }
      return false;
    });
  };

  const toggleActiveStatus = async (item: Datum) => {
    try {
      const response = await DrugNotAllowedwithActivityAxiosInstance.put(
        `updateDrugsNotAllowedwithAnotherActivity`,
        {
          id: item.id,
          is_active: !item.is_active,
          token,
        }
      );
      if (response.data.success) {
        setItems((prev) => ({
          ...prev,
          result: prev.result.map((i) =>
            i.id === item.id ? { ...i, is_active: !item.is_active } : i
          ),
        }));
        toast({
          title: "Success",
          description: `Status updated to ${!item.is_active ? "Active" : "Inactive"}.`,
        });
      }
    } catch (error: any) {
      toast({
        title: "Error",
        description: error.response?.data?.error || "Failed to update status",
        variant: "destructive",
      });
    }
  };

  // Table Columns Configuration
  const columns: ColumnDef<Datum>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const item = row.original; //Retrieve the full item
        return (
          <button onClick={() => handleOpenDialog(item)} className="id-button">
            {item.id}
          </button>
        );
      },
    },
    {
      accessorKey: "relation_name",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Relation Name
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const codes = row.getValue("relation_name") as string[];
        return Array.isArray(codes) ? codes.join(", ") : codes;
      },
    },
    {
      accessorKey: "drug",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Drug
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const MainDrug = row.getValue("drug") as string[];
        return Array.isArray(MainDrug) ? MainDrug.join(", ") : MainDrug;
      },
    },
    {
      accessorKey: "activity",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Activity
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Activity = row.getValue("activity") as string[];
        return Array.isArray(Activity) ? Activity.join(", ") : Activity;
      },
    },
    {
      accessorKey: "is_active",
      header: () => <div className="w-full text-center normal-case font-normal">Status</div>,
      cell: ({ row }) => {
        const item = row.original;
        const isDeleted = (item as any).is_deleted;
        const isRestricted = isRelationRestricted(item);
        return (
          <div className="w-full flex flex-col items-center justify-center gap-1">
            <button
              onClick={() => !isDeleted && !isRestricted && toggleActiveStatus(item)}
              disabled={!!isDeleted || isRestricted}
              title={isRestricted ? "Relation is restricted because an attached group is inactive. Reactivate the group to restore." : undefined}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                isDeleted || isRestricted
                  ? "opacity-40 cursor-not-allowed bg-gray-200"
                  : item.is_active
                  ? "bg-green-500"
                  : "bg-gray-300"
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  item.is_active && !isDeleted && !isRestricted ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
            {isRestricted && (
              <span
                className="text-[10px] font-semibold text-amber-700 bg-amber-100 px-1.5 py-0.5 rounded"
                title="Attached group is inactive"
              >
                Restricted
              </span>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="h5-container mx-auto px-1 pt-16 pb-4">


      <h5
        className="mb-6 flex items-center gap-2"
        style={{ fontWeight: "bolder", fontSize: "22px", marginTop: "15px" }}
      >
        <span className="icon-container">
          <i className="fa-solid fa-person-running"></i>
        </span>
        Drug Not Allowed With Activity
      </h5>
      <FileUpload fetchItems={fetchItems} />
      <DataTable2
        columns={columns}
        data={items.result}
        searchColumns={["relation_name"]}
        validateButtonLabel="Validate"
        addButtonLabel="Add New Relation "
        showAddButton={true}
        onEdit={handleEdit}
        onDelete={removeItem}
        onAdd={handleAddClick}
        onEditClick={handleEditClick}
        isRowRestricted={isRelationRestricted}
      />
      {Boolean(selectedItem) && (
        <dialog ref={dialogRef} className="custom-dialog" open>
          {selectedItem && (
            <div className="dialog-content">
              {/* top-dialog-close-icon */}
              <button className="dialog-close-icon" onClick={handleCloseDialog}>
                ×
              </button>
              {/* dialog-title */}
              <h2 className="dialog-title">
                <span>Details for ID:</span> {selectedItem.id}
              </h2>
              {/* Content */}
              <div className="dialog-grid">
                <div className="dialog-row single-row">
                  <div className="dialog-item">
                    <strong>Relation Name:</strong>{" "}
                    <span>{selectedItem.relation_name}</span>
                  </div>
                </div>
                <div className="dialog-row three-col-row">
                  <div className="dialog-item">
                    <strong> Drug Code:</strong>
                    <p>{selectedItem.drug.join(", ")}</p>
                  </div>
                  <div className="dialog-item">
                    <strong> Medical Drug Groups:</strong>
                    <p>
                      {selectedItem.drug_medicalgroups
                        .map((n) => n.name)
                        .join(", ")}
                    </p>
                  </div>
                  <div className="dialog-item">
                    <strong> Custom Drug Groups:</strong>
                    <p>
                      {selectedItem.drug_customgroups
                        .map((n) => n.name)
                        .join(", ")}
                    </p>
                  </div>
                </div>
                <div className="dialog-row four-col-row">
                  <div className="dialog-item">
                    <strong> Activity Type:</strong>
                    <p>{selectedItem.activity_type}</p>
                  </div>
                  <div className="dialog-item">
                    <strong>Activity Code:</strong>
                    <p>{selectedItem.activity.join(", ")}</p>
                  </div>
                  <div className="dialog-item">
                    <strong> Medical Activity Groups:</strong>
                    <p>
                      {selectedItem.activity_medicalgroups
                        .map((n) => n.name)
                        .join(", ")}
                    </p>
                  </div>
                  <div className="dialog-item">
                    <strong> Custom Activity Groups:</strong>
                    <p>
                      {selectedItem.activity_customgroups
                        .map((n) => n.name)
                        .join(", ")}
                    </p>
                  </div>
                </div>

                <div className="dialog-row two-col-row">
                  <div className="dialog-item">
                    <strong>Networks:</strong>{" "}
                    <span>
                      {selectedItem.networks.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6"> Apply TO Other Networks:</strong>{" "}
                    <span>{String(selectedItem.apply_to_other_networks)}</span>
                  </div>
                  <div className="dialog-item">
                    <strong>Insurance Plan:</strong>{" "}
                    <span>
                      {selectedItem.insuranceplan.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6">
                      {" "}
                      Apply To Other Insurance Plan :
                    </strong>{" "}
                    <span>
                      {String(selectedItem.apply_to_other_insuranceplan)}
                    </span>
                  </div>
                </div>
                <div className="dialog-row two-col-row">
                  <div className="dialog-item">
                    <strong>Payers:</strong>{" "}
                    <span>{selectedItem.payer.join(", ")}</span>
                    <strong className="ml-6">
                      {" "}
                      Apply To Other Payers:
                    </strong>{" "}
                    <span>{String(selectedItem.apply_to_other_payer)}</span>
                  </div>

                  <div className="dialog-item">
                    <strong>Provider:</strong>{" "}
                    <span>
                      {selectedItem.provider.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6"> Apply To Other Provider:</strong>{" "}
                    <span>{String(selectedItem.apply_to_other_providers)}</span>
                  </div>
                </div>
                <div className="dialog-row two-col-row">
                  <div className="dialog-item">
                    <strong>Policy:</strong>{" "}
                    <span>
                      {selectedItem.policy.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6"> Apply To Other Policy:</strong>{" "}
                    <span>{String(selectedItem.apply_to_other_policy)}</span>
                  </div>
                  <div className="dialog-item">
                    <strong>Patients:</strong>{" "}
                    <span>
                      {selectedItem.patients.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6"> Apply To Other Patients:</strong>{" "}
                    <span>{String(selectedItem.apply_to_other_patients)}</span>
                  </div>
                </div>
                <div className="dialog-row two-col-row">
                  <div className="dialog-item">
                    <strong>User Level:</strong>{" "}
                    <span>{selectedItem.user_level.join(", ")}</span>
                    <strong className="ml-6">
                      {" "}
                      Apply To Other User Level:
                    </strong>{" "}
                    <span>{String(selectedItem.apply_to_other_user)}</span>
                  </div>
                  <div className="dialog-item">
                    <strong>Doctor:</strong>{" "}
                    <span>
                      {selectedItem.doctor.map((n) => n.name).join(", ")}
                    </span>
                    <strong className="ml-6"> Apply To Other Doctors:</strong>{" "}
                    <span>{String(selectedItem.apply_to_other_doctor)}</span>
                  </div>
                </div>
                <div className="dialog-row two-col-row">
                  <div className="dialog-item">
                    <strong>Apply To VIP:</strong>{" "}
                    <span>{String(selectedItem.apply_to_vip)}</span>
                  </div>
                  <div className="dialog-item">
                    <strong>Is Active:</strong>{" "}
                    <span>{String(selectedItem.is_active)}</span>
                  </div>
                </div>
              </div>
              <button className="dialog-close-btn" onClick={handleCloseDialog}>
                Close
              </button>
            </div>
          )}
        </dialog>
      )}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {editIndex === null
                ? "Add Drug Not Allowed With Activity"
                : "Edit Drug Not Allowed With Activity"}
            </DialogTitle>
            </DialogHeader>
          <div className="grid grid-cols-2 gap-4 mt-4">
            {/* First Column */}
            <div>
              <div className="mb-12">
                <Label className="m-2">Relation Name:</Label>

                <Input
                  value={relationName}
                  onChange={(e) => setRelationName(e.target.value)}
                  placeholder="Enter Relation Name"
                />
              </div>
              <div className={`mb-${hasSelectValue ? "2" : "4"} `}>
                <Label htmlFor="main_diagnoses">Main Activity:</Label>

                <Select
                  onValueChange={(value) => setSelectedActivityOption(value)}
                >
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select an option" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="list_of_Activity_code">
                      List of Activity Code
                    </SelectItem>
                    <SelectItem value="medical_Activity_groups">
                      Medical Activity Groups
                    </SelectItem>
                    <SelectItem value="custom_Activity_groups">
                      Custom Activity Groups
                    </SelectItem>
                  </SelectContent>
                </Select>

                {selectedActivityOption === "list_of_Activity_code" && (
                  <div className="mt-2 mb-4">
                    <Label htmlFor="activity_type"> Activity Type:</Label>
                    <ActivitySelector
                      onSelectActivity={handleActivityTypeChange}
                      selectedActivityType={ActivityType}
                    />
                  </div>
                )}

                {selectedActivityOption === "medical_Activity_groups" && (
                  <div className="mt-2">
                    <ListOfActivityMedical
                      onChange={handleActivityMedicalGroupsChange}
                      defaultValue={activityMedicalGroups}
                      clear={clearActivityMedicalGroups}
                    />
                  </div>
                )}

                {selectedActivityOption === "custom_Activity_groups" && (
                  <div className="mt-2">
                    <ListOfActivityCustom
                      onChange={handleActivityCustomGroupsChange}
                      defaultValue={activityCustomGroups}
                      clear={clearActivityCustomGroups}
                    />
                  </div>
                )}
              </div>

              <div className="mb-4">
                <Label>Providers:</Label>
                <ListOfProviderName
                  onChange={handleProviderChange}
                  defaultValue={provider}
                  clear={clearProvider}
                />
              </div>

              <div className="mb-4">
                <Label>Networks:</Label>
                <ListOfNewNetworkName
                  onChange={handleNetworkChange}
                  defaultValue={networks}
                  clear={clearNetworks}
                />
              </div>

              <div className="mb-4">
                <Label>Insurance Plan:</Label>
                <ListOfInsuranceplanName
                  onChange={handleInsurancePlanChange}
                  defaultValue={insuranceplan}
                  clear={clearInsuranceplan}
                />
              </div>
              <div className="mb-4">
                <Label> Payer:</Label>
                <Input
                  value={Payer.join(",")}
                  onChange={(e) => setPayer([e.target.value])}
                  placeholder="Enter Payer"
                />
              </div>
              <div className="mb-4">
                <Label>Doctor:</Label>
                <ListOfDoctorName
                  onChange={handleDoctorChange}
                  defaultValue={doctor}
                  clear={clearDoctor}
                />
              </div>
              <div className="mb-4">
                <Label>Patients:</Label>
                <Patient
                  onChange={handlePatientChange}
                  defaultValue={patients}
                  clear={clearPatient}
                />
              </div>
              <div className="mb-4">
                <Label>Policy:</Label>
                <PolicyNames
                  onChange={handlePoliciesChange}
                  defaultValue={policy}
                  clear={clearPolicy}
                />
              </div>
              <div>
                <Label>User Level:</Label>
                <Input
                  value={userLevel.join(",")}
                  onChange={(e) => setUserLevel([e.target.value])}
                  placeholder="Enter User Level"
                />
              </div>
              <div className="mb-3 w-80">
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>Is Active:</AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="is_active"
                            value="true"
                            checked={isActive === true}
                            onChange={(e) =>
                              setIsActive(e.target.value === "true")
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="is_active"
                            value="false"
                            checked={isActive === false}
                            onChange={(e) =>
                              setIsActive(e.target.value === "true")
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
            </div>
            {/* Second Column */}
            <div>
              <div
                className={`min-h-${
                  hasSelectValue && hasSelectValue2
                    ? "[44px]"
                    : hasSelectValue2
                    ? "[134px]"
                    : ""
                } m-1 min-w-[100px]`}
              >
                <Label htmlFor="main_diagnoses">Main Drug:</Label>

                <Select onValueChange={(value) => setSelectedDrugOption(value)}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select an option" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="list_of_Drug_code">
                      List of Drug Code
                    </SelectItem>
                    <SelectItem value="medical_Drug_groups">
                      Medical Drug Groups
                    </SelectItem>
                    <SelectItem value="custom_Drug_groups">
                      Custom Drug Groups
                    </SelectItem>
                  </SelectContent>
                </Select>

                {selectedDrugOption === "list_of_Drug_code" && (
                  <div className="mt-2">
                    <ListOfDrugCode
                      onChange={handleDrugChange}
                      defaultValue={drug}
                      clear={clearDrug}
                    />
                  </div>
                )}

                {selectedDrugOption === "medical_Drug_groups" && (
                  <div className="mt-2">
                    <ListOfDrugMedical
                      onChange={handleDrugMedicalGroupsChange}
                      defaultValue={drugMedicalGroups}
                      clear={clearDrugMedicalGroups}
                    />
                  </div>
                )}

                {selectedDrugOption === "custom_Drug_groups" && (
                  <div className="mt-2">
                    <ListOfDrugCustom
                      onChange={handleDrugCustomGroupsChange}
                      defaultValue={drugCustomGroups}
                      clear={clearDrugCustomGroups}
                    />
                  </div>
                )}
              </div>
              <div
                className={`mt-${
                  hasSelectValue && hasSelectValue2
                    ? "1"
                    : hasSelectValue2
                    ? ""
                    : hasSelectValue
                    ? "5"
                    : "4"
                } mb-${hasSelectValue ? "4" : "3"} }  w-80`}
              >
                <Accordion type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger>Apply To Vip:</AccordionTrigger>
                    <AccordionContent>
                      <div>
                        <label>
                          <input
                            type="radio"
                            name="Vip"
                            value="true"
                            checked={apply_to_other_vip === true}
                            onChange={(e) =>
                              setApply_to_other_vip(e.target.value === "true")
                            }
                          />{" "}
                          True
                        </label>
                        <label className="ml-4">
                          <input
                            type="radio"
                            name="Vip"
                            value="false"
                            checked={apply_to_other_vip === false}
                            onChange={(e) =>
                              setApply_to_other_vip(e.target.value === "true")
                            }
                          />{" "}
                          False
                        </label>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
              {selectedActivityOption === "list_of_Activity_code" &&
                ActivityType && (
                  <div className="mt-6">
                    <ListofActivityCode
                      onChange={handleActivityChange}
                      type={ActivityType}
                      defaultValue={activity}
                      clear={clearActivity}
                      isValid={activityTypeisValid}
                    />
                  </div>
                )}
              <div>
                <div className="mb-3 w-80">
                  <Accordion type="single" collapsible>
                    <AccordionItem value="item-1">
                      <AccordionTrigger>
                        Apply To Other Providers?
                      </AccordionTrigger>
                      <AccordionContent>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="Providers"
                              value="true"
                              checked={applyToOtherProviders === true}
                              onChange={(e) =>
                                setApplyToOtherProviders(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            True
                          </label>
                          <label className="m-2">
                            <input
                              type="radio"
                              name="Providers"
                              value="false"
                              checked={applyToOtherProviders === false}
                              onChange={(e) =>
                                setApplyToOtherProviders(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            False
                          </label>
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </div>
                <div className="mb-3 w-80">
                  <Accordion type="single" collapsible>
                    <AccordionItem value="item-1">
                      <AccordionTrigger>
                        Apply To Other Networks:
                      </AccordionTrigger>
                      <AccordionContent>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="Networks"
                              value="true"
                              checked={apply_to_other_networks === true}
                              onChange={(e) =>
                                setApply_to_other_networks(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            True
                          </label>
                          <label className="ml-4">
                            <input
                              type="radio"
                              name="Networks"
                              value="false"
                              checked={apply_to_other_networks === false}
                              onChange={(e) =>
                                setApply_to_other_networks(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            False
                          </label>
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </div>
                <div className="mb-3 w-80">
                  <Accordion type="single" collapsible>
                    <AccordionItem value="item-1">
                      <AccordionTrigger>
                        Apply To Other Insurance Plan:
                      </AccordionTrigger>
                      <AccordionContent>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="Insurance"
                              value="true"
                              checked={apply_to_other_insuranceplan === true}
                              onChange={(e) =>
                                setapply_to_other_insuranceplan(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            True
                          </label>
                          <label className="ml-4">
                            <input
                              type="radio"
                              name="Insurance"
                              value="false"
                              checked={apply_to_other_insuranceplan === false}
                              onChange={(e) =>
                                setapply_to_other_insuranceplan(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            False
                          </label>
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </div>
                <div className="mb-3 w-80">
                  <Accordion type="single" collapsible>
                    <AccordionItem value="item-1">
                      <AccordionTrigger>Apply To Other Payer:</AccordionTrigger>
                      <AccordionContent>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="Payer"
                              value="true"
                              checked={apply_to_other_payer === true}
                              onChange={(e) =>
                                setapply_to_other_payer(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            True
                          </label>
                          <label className="ml-4">
                            <input
                              type="radio"
                              name="Payer"
                              value="false"
                              checked={apply_to_other_payer === false}
                              onChange={(e) =>
                                setapply_to_other_payer(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            False
                          </label>
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </div>
                <div className="mb-3 w-80">
                  <Accordion type="single" collapsible>
                    <AccordionItem value="item-1">
                      <AccordionTrigger>
                        Apply To Other Doctors:
                      </AccordionTrigger>
                      <AccordionContent>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="Doctor"
                              value="true"
                              checked={applyToOtherDoctor === true}
                              onChange={(e) =>
                                setApplyToOtherDoctor(e.target.value === "true")
                              }
                            />{" "}
                            True
                          </label>
                          <label className="ml-4">
                            <input
                              type="radio"
                              name="Doctor"
                              value="false"
                              checked={applyToOtherDoctor === false}
                              onChange={(e) =>
                                setApplyToOtherDoctor(e.target.value === "true")
                              }
                            />{" "}
                            False
                          </label>
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </div>
                <div className="mb-3 w-80">
                  <Accordion type="single" collapsible>
                    <AccordionItem value="item-1">
                      <AccordionTrigger>
                        Apply To Other Patients:
                      </AccordionTrigger>
                      <AccordionContent>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="Patients"
                              value="true"
                              checked={apply_to_other_patients === true}
                              onChange={(e) =>
                                setApply_to_other_patients(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            True
                          </label>
                          <label className="ml-4">
                            <input
                              type="radio"
                              name="Patients"
                              value="false"
                              checked={apply_to_other_patients === false}
                              onChange={(e) =>
                                setApply_to_other_patients(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            False
                          </label>
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </div>

                <div className="mb-3 w-80">
                  <Accordion type="single" collapsible>
                    <AccordionItem value="item-1">
                      <AccordionTrigger>
                        Apply To Other Policy:
                      </AccordionTrigger>
                      <AccordionContent>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="Policy"
                              value="true"
                              checked={apply_to_other_policy === true}
                              onChange={(e) =>
                                setApply_to_other_policy(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            True
                          </label>
                          <label className="ml-4">
                            <input
                              type="radio"
                              name="Policy"
                              value="false"
                              checked={apply_to_other_policy === false}
                              onChange={(e) =>
                                setApply_to_other_policy(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            False
                          </label>
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </div>
                <div className="mb-3 w-80">
                  <Accordion type="single" collapsible>
                    <AccordionItem value="item-1">
                      <AccordionTrigger>Apply To Other User:</AccordionTrigger>
                      <AccordionContent>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="user"
                              value="true"
                              checked={apply_to_other_user === true}
                              onChange={(e) =>
                                setApply_to_other_user(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            True
                          </label>
                          <label className="ml-4">
                            <input
                              type="radio"
                              name="user"
                              value="false"
                              checked={apply_to_other_user === false}
                              onChange={(e) =>
                                setApply_to_other_user(
                                  e.target.value === "true"
                                )
                              }
                            />{" "}
                            False
                          </label>
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>

          <DialogFooter className="gap-2 m-4">
            <Button
              onClick={() => {
                if (editIndex === null) {
                  addItem();
                } else {
                  updateItem(editIndex);
                }
              }}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {editIndex === null ? "Add Relation " : "Update Relation "}
            </Button>
            <Button
              variant="outline"
              onClick={(e) => {
                setEditIndex(null);
                clear();
                setIsDialogOpen(false);
              }}
            >
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Toaster />
    </div>
  );
};

export default DrugNotAllowedwithActivity;
